import validate from "/opt/buildhome/repo/node_modules/nuxt/dist/pages/runtime/validate.js";
import tenant_45global from "/opt/buildhome/repo/middleware/tenant.global.ts";
import manifest_45route_45rule from "/opt/buildhome/repo/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  tenant_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}